import store from '../../store'

export const theme = {
    toggleTheme: () => store.dispatch("theme/toggleDark"),
    isDarkTheme: () => store.getters["theme/isDarkTheme"]
}

export default {
    install(Vue) {
        Vue.prototype.$toggleTheme = theme.toggleTheme;
        Vue.prototype.$isDarkTheme = theme.isDarkTheme;
    }
}
